import { TFunction } from 'i18next';
import { DateTime } from 'luxon';

export function isNewIngTfiAddressDisplay() {
  const START_DATE_STRING = '2023-09-18'
  const startDate = DateTime.fromISO(START_DATE_STRING).startOf('day')
  const currentDate = DateTime.local().startOf('day');

  return currentDate >= startDate;
}

export const generateUuid = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.random() * 16 | 0;
    const value = char === 'x' ? random : (random % 4 + 8);
    return value.toString(16);
  });
};


export const removeAllSpacesFromString = (str: string) => str.replace(/\s/g, '');

export const mergeRefs = <T>(...refs: (React.Ref<T> | undefined | null)[]): React.RefCallback<T> => {
  return (node: T) => {
    refs.filter(ref => ref != null).forEach(ref => {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref && typeof ref === 'object') {
        (ref as React.MutableRefObject<T | null>).current = node;
      } else {
        console.warn('mergeRefs: Unexpected ref type', ref);
      }
    });
  };
}

export const dispatchCustomEvent = <TDetails = unknown>(
  name: string,
  detail?: TDetails
) => {
  const event = new CustomEvent<TDetails>(name, { detail });
  document.dispatchEvent(event);
};

export const openInNewWindow = (url: string) => {
  if (!url) return;
  window.open(url, '_blank', 'noopener,noreferrer');
};
